<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <!-- <div style="margin:5px;float:right">
            <el-button size="mini" type="success" @click="openModel">添加客户留言</el-button>
        </div> -->

        <el-table :data="tableData" border style="width: 100%;" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="ask_user_id_text" label="用户" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="tel" label="手机号码" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="ask_content" label="留言" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="留言时间" show-overflow-tooltip align="center">
            </el-table-column>
            <!-- <el-table-column prop="reply_user_id_text" label="回复人员" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="reply_content" label="回复内容" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="update_time" label="回复时间" show-overflow-tooltip align="center">
            </el-table-column> -->
            <!-- <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">回复</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog title="留言" :visible.sync="dialogVisible">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item label="客户留言">
                        <el-input v-model="ruleForm.ask_content" type="textarea" :autosize="{ minRows: 4, maxRows: 8}"
                            placeholder="请输入内容" style="width:70%"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="回复" :visible.sync="dialogVisibles">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForms" :rules="rule" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item label="留言回复">
                        <el-input v-model="ruleForms.reply_content" type="textarea" :autosize="{ minRows: 4, maxRows: 8}"
                            placeholder="请输入内容" style="width:70%"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibles = false" size='small'>取 消</el-button>
                <el-button @click="hFsubForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,

        },
        data() {
            return {
                namenc: false,
                names: '',
                pageSize: 10,
                curPage: 1,
                count: 0,
                tableData: [],
                loadings: false,
                height: null,
                dialogVisible: false,
                ruleForm: {
                    ask_content:''
                },
                rules: {},
                dialogVisibles: false,
                ruleForms: {
                    reply_content:''
                },
                rule: {},

                eid: '',
                // 操作项目的id
                operateProjectId: null,
            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.getHeight()
            that.search()
            that.gettj()
            that.getxm()
        },
        methods: {
            getHeight() {
                let that = this // window.innerHeight   获取动态表格高度
                that.height = window.innerHeight - 400 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 400 + 'px'
                }
            },
            search() {
                let that = this
                axios
                    .post("/admin/lgAsk/index", {
                        limit: that.pageSize,
                        page: that.curPage,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.tableData = response.data.data.data
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.curPage = val
                that.search()
            },
            getxm() {
                let that = this
                axios
                    .post("/admin/lgProject/index", {
                        limit: 10,
                        page: 1,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.project_options = response.data.data.data
                    })
                    .catch(error => {})
            },
            gettj() {
                let that = this
                axios
                    .post("/admin/lgSource/index", {
                        pid: 0
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.source_options = response.data.data
                    })
                    .catch(error => {})
            },


            openModel() {
                let that = this
                that.dialogVisible = true
                that.ruleForm.ask_content = ''
            },
            subForm() {
                let that = this
                    axios
                        .post("/admin/lgAsk/Madd", {
                            ask_content:that.ruleForm.ask_content
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisible = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                

            },
            //编辑
            async handleClick(row) {
                let that = this
                that.dialogVisibles = true
                that.ruleForms.reply_content = row.reply_content == ''?'':row.reply_content
                that.eid = row.id
            },

            hFsubForm(){
                 let that = this
                    axios
                        .post("/admin/lgAsk/Medit", {
                            reply_content:that.ruleForms.reply_content,
                            id :that.eid
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisibles = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
            }

        },
    }
</script>

<style>
</style>